import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getCategories = state => state.bookingCategories

export const selectCategoriesFetching = state => path(['bookingCategories', 'isFetching'], state)

export const selectCategories = createSelector(getCategories, categories => {
    if (!(isEmpty(categories.entities) || isEmpty(categories.result))) {
        const items = categories.entities.categories
        return categories.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/bookingSelectors/bookingCategories.js